import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Button from 'components/UI/Buttons/Button/Button';
import { getRoutesUri } from 'services/generic';

import styles from './DetailsProductsActions.module.scss';

export default function DetailsProductsActions(): JSX.Element {
  const { t } = useTranslation('ordersPage');

  return (
    <div className={styles.actions}>
      <Button
        model={'primary'}
        component={Link}
        to={getRoutesUri<string>('customerAccountOrderHistory')}
      >
        {t('LABEL_ORDER_BACK_ORDERS')}
      </Button>
    </div>
  );
}
